<template>
  <Admin v-if="this.$router.currentRoute.name == 'admin' && !$isMobile()" />
  <AdminMobile v-else-if="this.$router.currentRoute.name == 'admin' && $isMobile()" />
  <App v-else  />
</template>

<script>
import Admin from './Admin.vue'
import AdminMobile from './AdminMobile.vue'
import App from './App.vue'

export default {
  name: 'Main',
  components: { App,Admin,AdminMobile},
  methods: {},
  mounted(){
    console.log(this.$router.currentRoute.name)
  },
  data: function () {
    return {}
  }
}
</script>

<style>
html,body{
  max-width:100vw;
  width:100vw;
}
</style>
